import Vue from "vue";
import { Loading } from "element-ui";

Vue.use(Loading);

// see https://forum.vuejs.org/t/using-mixins-with-typescript/24256/6
const LoadingMixin = Vue.extend({
  data() {
    return {
      loading_: false,
    };
  },
  computed: {
    loading(): boolean {
      return this.loading_;
    },
  },
  methods: {
    async withLoading(action: () => Promise<void>) {
      this.loading_ = true;
      try {
        await action();
      } finally {
        this.loading_ = false;
      }
    },
  },
});

export default LoadingMixin;
